<template lang="html">
  <div class="merchant-container">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{$t('message.function')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('message.functionManage')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flex-row second-tip">
      <div class="title">
      </div>
      <div class="flex-row search-container">
        <div class="select-input-container" style="right:50px" >
        <el-input class="reachInput"
                  :placeholder="$t('message.enterKeyword')"
                  v-model="merchantSearch"  @keyup.enter.native="searchMerchantlist"
                  clearable>
        </el-input>
          <el-select class="rearchSelect" v-model="queryType" :placeholder="$t('message.pleaseChoose')"  >
            <el-option v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value" @click.native="getDivision()">
            </el-option>
          </el-select>
        </div>
        <el-button  class="search-btn" icon="el-icon-search" @click="searchMerchantlist"></el-button>

        <div v-if="queryFlag">
            <router-link :to="{path:'/functionAdd/'}"><el-button type="primary" class="verifone-btn" plain icon="el-icon-plus">{{$t('message.add')}}</el-button></router-link>
        </div>

        <div v-else>
            <el-button disabled class="verifone-btn" type="primary" plain icon="el-icon-plus">{{$t('message.add')}}</el-button>
        </div>
      </div>
    </div>
    <div class="verifone-panel">
      <div class="appManagement-table-main btn-table">
        <template>
          <el-table :data="tableData" style="width: 100%" tooltip-effect="dark">
             <el-table-column prop="id"  v-if="show"> </el-table-column>
            <el-table-column  prop="groupName"  :label="$t('message.groupName')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="functionType" :label="$t('message.functionType')" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="scope.row.functionType == 0" size="small">{{ $t('message.locationService') }}</span>
              </template>
            </el-table-column>
            <el-table-column  prop="userName" :label="$t('message.creator')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  prop="createdTime" :label="$t('message.createTime')" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column  :label="$t('message.operation')" width="240" align="center" v-if="queryFlag">
              <template slot-scope="scope">
               <!-- <router-link :to="{path:'/FunctionEdit/',query:{arry:scope.row}}"> -->
                  <el-button type="success" class="op-btn verifone-btn" plain icon="el-icon-edit" @click="handleModify(scope.row)">{{$t('message.edit')}}</el-button>
            <!--    </router-link> -->
                <el-button type="danger" class="op-btn verifone-btn" plain icon="el-icon-close" @click="showDeleteDialog(scope.row)">{{$t('message.delete')}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  :label="$t('message.operation')" width="240" align="center" v-else>
              <template slot-scope="scope">
                  <router-link :to="{path:'/FunctionAdd/',query:{id:scope.row.id}}">
                      <el-button type="success" disabled class="op-btn verifone-btn" plain icon="el-icon-edit">{{$t('message.edit')}}</el-button>
                </router-link>
                <el-button disabled type="danger" class="op-btn verifone-btn" plain icon="el-icon-close" @click="showDeleteDialog(scope.row)">{{$t('message.delete')}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>

        <div class="pagination-main">
          <el-pagination @current-change="handleCurrentChange"
                         background layout="prev, pager, next"
                         :current-page="pageNum"
                         :page-count="pageCount">
          </el-pagination>
        </div>
      </div>
    </div>

    <!--删除弹框 -->
    <el-dialog title="" :visible.sync="deleteTipVisible" custom-class="tips-dialog" class="quit-dialog warn-dialog">
        <div class="warn-container flex-row">
            <img class="warn-icon" alt="" src="static/img/alertWarn.png">
            <span>&nbsp;&nbsp;{{$t('message.warn')}}</span>
        </div>
        <div class="dialog-body">
            <span>{{$t('message.deleteGroupFunction')}}</span><span>{{delGroupName}}"</span>
            <span>{{$t('message.function')}}</span>
            <span>?</span>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button class="verifone-btn" type="primary" plain @click="deleteTipVisible = false;">{{$t('message.no')}}</el-button>
            <el-button class="verifone-btn" type="primary" @click="deleteMerchant">{{$t('message.yes')}}</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageNum :1,//当前页
        pageCount:1,
        deleteMerchantId :'',
        taskName: '',
        merchantSearch:'',
        historySearch: '',
        deleteTipVisible : false,
        researchType:0,//0 为查询分页查询APP 1搜索APP
        tableData: [],
        groupName:'',
        functionType:'',
        userName:'',
        createdTime:'',
        queryFlag: false,
        delGroupName:'',
        deleteGroupFunction:'',
        queryOptions: [ {
          value: 0,
          label: this.$t('message.groupName')
        }],
        queryType: 0,
        uploadSuccess: this.$t('message.uploadSuccess'),
        deleteSuccess: this.$t('message.deleteSuccess'),
        xmlCheck: this.$t('message.xmlCheck'),
      }
    },
    mounted() {
      this.queryMerchantList();
      this.setQuery();
    },
    methods: {
      getDivision(){
        this.merchantSearch='';
      },
        setQuery() {
            let roleArr = sessionStorage.getItem('verifoneRoleList').split(',').map(str => parseInt(str));
            this.queryFlag = !roleArr.includes(11);
        },
      handleCurrentChange(val) {
        this.pageNum = val;
        if(this.researchType == 0) {
          this.queryMerchantList();
        }
        else if(this.researchType == 1) {
          this.searchMerchantlist();
        }
      },
      queryMerchantList() {
        let that = this,
            obj = {
              pageNum:this.pageNum
            };

        this.$axios({
            method: 'post',
            url: '/marketplace/gruop/findGroupFunctionPage',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.code !="00") {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.researchType = 0;
            that.pageCount = response.data.data.pages;
            that.tableData= response.data.data.list;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      searchMerchantlist() {
        let that = this,
            obj = {
              queryType:this.queryType,
              queryInfo:this.merchantSearch,
              pageNum:this.pageNum
            };

        if(this.merchantSearch == '') {
            this.pageNum = 1;
            this.historySearch = '';
            this.queryMerchantList();
            return;
        }

        //new query => refresh page
        if(this.merchantSearch != this.historySearch) {
            this.pageNum = 1;
        }else {
            obj.pageNum = this.pageNum;
        }

        this.$axios({
            method: 'post',
            url: '/marketplace/gruop/findGroupFunctionQuery',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.code != "00") {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.researchType = 1;
            that.tableData = response.data.data.list;
            that.pageCount = response.data.data.pages;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      showDeleteDialog(row) {
        this.deleteTipVisible = true;
        this.deleteMerchantId = row.id;
        this.delGroupName = row.groupName;
      },
      deleteMerchant () {
        console.log("del"+this.groupName)
        console.log("Del"+this.functionType)
        let that = this,
            obj = {
              id:this.deleteMerchantId
            };
        this.$axios({
            method: 'post',
            url: '/marketplace/function/groupFunctionDel',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.code != "00") {
            this.$message({
              type: "error",
              message: response.data.desc,
              duration:'3000',
            });
            return;
          }else {
            that.deleteMerchantId = '';
            that.deleteTipVisible = false;
            that.$message({
              type: "success",
              message: this.deleteSuccess,
              duration:'3000',
            });
            if(that.researchType == 0) {
              that.queryMerchantList();
            }
            else if(that.researchType == 1) {
              this.searchMerchantlist();
            }
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      handleModify(row) {
          this.$router.push({path:'/FunctionEdit/',query:{arry:row}});
        },

    }
  }
</script>

<style lang="css" scoped="scope">

  .select-input-container{
    border: #8c939d;
  }
  .appManagement-container {
    /*background-color: #E0EAF4;*/
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    /*justify-content: center;*/
    align-items: center;
    width: 100%;
  }
  .appManagement-table {
    width:100%;
    padding:10px 30px;
  }
  .appManagement-table-main {
    padding: 20px;
    background-color: #fff;
  }
  .pagination-main {
    padding:30px 0 10px;
    background: #fff;
    width: 100%;
  }
  .appManagement-search .el-input__inner {
    border-radius: 20px;
  }
 .reachInput {
    position: relative;
   /* border-right:none!important;*/
    left: 40px;
  }
  .search-btn {
    margin-right: 30px;
  }
  .rearchSelect {
    width: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/function/FunctionList.vue